module.exports = __webpack_public_path__ + "static/media/logo-alfa.392860af.png";